import React from "react";
import './ContactForm.css';
import { useTranslation } from 'react-i18next';
import useContactFormSubmit from '../../api/useContactFormSubmit';

function ContactForm() {
  const { t } = useTranslation();
  const { status, formData, handleSubmit, updateFormData } = useContactFormSubmit();

  const handleInputChange = (e) => {
    updateFormData(e.target.name, e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
  };

  return (
    <section className="contact" id="contact">
      <h2>{t('contactForm.title')}</h2>
      <p>{t('contactForm.paragraph')}</p>
      <form className="contact-form" onSubmit={onSubmit}>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          required
          placeholder={t('contactForm.emailLabel')}
        />
        <textarea
          name="message"
          value={formData.message}
          onChange={handleInputChange}
          required
          placeholder={t('contactForm.messageLabel')}
        />
        <button type="submit" disabled={status.loading}>
          {status.loading ? t('contactForm.submitButton.submitting') : t('contactForm.submitButton.idle')}
        </button>
        
        
        {status.result && (
          <p className={`form-status-message ${status.result.type}`}>
            {t(status.result.messageKey, { details: status.result.details })}
          </p>
        )}
      </form>
    </section>
  );
}

export default ContactForm;